import React, { useMemo, memo } from 'react';
import { useDrag } from 'react-dnd';

export const SourceContainer = memo(function SourceContainer({ type, object, enrolledId, children, furtherAction, preventDrag }) {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: type,
        item: [object, enrolledId],
        canDrag: !preventDrag,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const didDrop = monitor.didDrop();
            if (!didDrop && furtherAction) {
                furtherAction(); 
            }
        },
    }), [preventDrag, object]);

    const containerStyle = useMemo(() => ({
        opacity: isDragging ? 0.4 : 1,
        cursor: preventDrag ? 'default' : 'move',
    }), [isDragging, preventDrag]);
    return (<div ref={drag} style={containerStyle}  >
			{children}
		</div>);
});
